var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.computedSettings,"series":_vm.computedXAxisData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }